// extracted by mini-css-extract-plugin
module.exports = {"textareaContainer":"styles_textareaContainer__5xXOc","resizer":"styles_resizer__Ugy0v","characterCount":"styles_characterCount__PPr8T"};